import CaseDetail from "./component";
export default CaseDetail;